import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getCommunications, getCommunicationsbycustomerId } from "../../services/Communicationservices";
import { connect } from "react-redux";
import { useParams, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { formatDate, formatTime12Hour } from "../../utils/commonutils";

const Communicationdetail = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [Communication , setCommunication]= useState([])
  const allLogs = [
    {
      date: "2025-07-17",
      time: "10:30 AM",
      type: "Outgoing",
      channel: "Call",
      subject: "Site visit confirmation",
      sentBy: "CRM Executive",
      recipient: "Riya Sharma",
    },
    {
      date: "2025-07-15",
      time: "05:00 PM",
      type: "Outgoing",
      channel: "SMS",
      subject: "Reminder for visit",
      sentBy: "CRM Executive",
      recipient: "Riya Sharma",
    },
  ];
     const { id } = useParams()
  const FetchCommincation = async () =>{
  const res = await getCommunicationsbycustomerId(props , id)
  setCommunication(res?.data?.items || [])
  }
  useEffect(() => {
    const filtered = Communication?.filter(
      (log) =>
        log.subject.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.channel.toLowerCase().includes(searchTerm.toLowerCase()) 
    );
    setFilteredLogs(filtered);
  }, [searchTerm , Communication ]);
 useEffect(()=>{
FetchCommincation()
 },[])
  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontSize="18px" fontWeight={600}>
            Communication History
          </Typography>
          <TextField
            size="small"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: 260 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />
        {filteredLogs.length === 0 ? (
          <Typography>No communication history found.</Typography>
        ) : (
          <Box>
            {filteredLogs.map((log, index) => (
              <Card
                key={index}
                sx={{
                  mb: 1,
                  border: "1px solid lightgray",
                  boxShadow: 0,
                  background: "#f9f9f9",
                }}
              >
                <CardContent>
                  <Box display="flex" justifyContent="space-between">
                    <Typography fontWeight={600}>{log.subject}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formatDate(log.date)} | {formatTime12Hour(log.time)}
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  <Typography variant="body2" color="textSecondary">
                    <strong>Type:</strong> {log.type} &nbsp;|&nbsp;
                    <strong>Channel:</strong> {log.channel} &nbsp;|&nbsp;
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(Communicationdetail));